export default __webpack_public_path__ + "static/media/bottom-arrow.dd9f6ad6.svg";